import { GeoCoordinates, isUndefined } from '@aloft/toolkit-shared';

import { Position } from 'geojson';

export function positionsToGeoCoordinates(positions: Position[]): GeoCoordinates {
  const coordinates: GeoCoordinates = [];

  for (const [lng, lat] of positions) {
    if (isUndefined(lng) || isUndefined(lat)) continue;
    coordinates.push([lng, lat]);
  }

  return coordinates;
}
